import React from 'react';
import { ILenderCompanyData } from '../../types/lenders/ILenderCompany';
import { SimpleModalTW } from '../../tailwindComponents/modals/SimpleModalTW';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { Dialog } from '@headlessui/react';
import { ButtonTW, ColorlessButtonTW } from '../../tailwindComponents/buttonTW/ButtonTW';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { useUpdateLenderMutation } from '../../API/lenders/LenderCompanyApi';

interface IDeactivateLenderCompanyModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  lenderCompany: ILenderCompanyData;
}

export const DeactivateLenderCompanyModal: React.FC<IDeactivateLenderCompanyModalProps> = ({
  open,
  setOpen,
  lenderCompany,
}) => {
  const [updateLenderCompany, { error, isLoading }] = useUpdateLenderMutation();

  const handleUpdate = async () => {
    const result = await updateLenderCompany({ id: lenderCompany.id, body: { isActive: false } });
    if (checkForMutationSuccess(result, 'Deactivate Lender Company', 'Error Deactivating Lender Company')) {
      setOpen(false);
    }
  };

  return (
    <SimpleModalTW open={open} setOpen={setOpen}>
      <ErrorMessageTW rtkError={error} />
      <div className="sm:flex sm:items-start">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
            Deactivate Lender
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Are you sure you want to deactivate the lender company <strong>{lenderCompany.name}</strong>?
            </p>
          </div>

          <div className={'gap-4 pt-4 sm:flex sm:flex-row-reverse'}>
            <ColorlessButtonTW
              className="bg-red-500 text-white hover:bg-red-600"
              disabled={isLoading}
              onClick={handleUpdate}
            >
              Confirm
            </ColorlessButtonTW>
            <ButtonTW type="button" secondary onClick={() => setOpen(false)}>
              Cancel
            </ButtonTW>
          </div>
        </div>
      </div>
    </SimpleModalTW>
  );
};
